/**
 * 自定义属性值：权限查询 / 添加结果解析。
 * 平台：get-custom-attribute-permission-config / add-custom-attribute-value
 */

/** @returns {Record<string, boolean>} attributeId → 是否可自定义 */
export function parseCustomAttributePermission(res) {
  const rows = Array.isArray(res?.data)
    ? res.data
    : (Array.isArray(res?.info?.data)
      ? res.info.data
      : (Array.isArray(res) ? res : []));
  const map = {};
  rows.forEach((row) => {
    if (!row || typeof row !== 'object') return;
    const id = row.attribute_id ?? row.attributeId;
    if (id == null || id === '') return;
    if (Number(row.has_permission ?? row.hasPermission) === 1) {
      map[String(id)] = true;
    }
  });
  return map;
}

/** @returns {{ id: string, name: string, nameCn: string } | null} */
export function parseAddedCustomAttributeValue(res) {
  const info = res?.info && typeof res.info === 'object' && !Array.isArray(res.info)
    ? res.info
    : res;
  if (!info || typeof info !== 'object') return null;
  const id = info.attribute_value_id ?? info.attributeValueId;
  const name = String(
    info.attribute_value_name
    ?? info.attributeValueName
    ?? info.attribute_value
    ?? info.attributeValue
    ?? '',
  ).trim();
  if (id == null || id === '' || !name) return null;
  return {
    id: String(id),
    name,
    nameCn: name,
  };
}
